<template>
  <div class="step">
    <h2 class="h2 text-light">Locatie</h2>
    <h1 class="h1">Ophaallocatie</h1>

    <div
      @click="setType('woning')"
      class="card"
      :class="{ active: type == 'woning' }"
    >
      <div class="card__icon">
        <i class="fas fa-home"></i>
      </div>
      <div class="card__content">
        <h3 class="h2">Vanaf een woning</h3>
        <span
          class="glyphicon glyphicon-pencil"
          aria-hidden="true"
          data-toggle="tooltip"
          data-placement="left"
          title="Edit"
        ></span>
        <p class="p">Bijv. onderling gekocht en verkocht</p>
      </div>
    </div>

    <div
      @click="setType('2dehands')"
      class="card"
      :class="{ active: type == '2dehands' }"
    >
      <div class="card__icon">
        <i class="fas fa-comments"></i>
      </div>
      <div class="card__content">
        <h3 class="h2">Via een online marktplaats</h3>
        <p class="p">Bijv. Marktplaats.nl of 2dehands.be</p>
      </div>
    </div>

    <div
      @click="setType('winkel')"
      class="card"
      :class="{ active: type == 'winkel' }"
    >
      <div class="card__icon">
        <i class="fas fa-store"></i>
      </div>
      <div class="card__content">
        <h3 class="h2">Vanaf een winkel/bedrijf</h3>
        <p class="p">Bijv. IKEA of Mediamarkt</p>
      </div>
    </div>

    <div
      @click="setType('veiling')"
      class="card"
      :class="{ active: type == 'veiling' }"
    >
      <div class="card__icon">
        <i class="fas fa-gavel"></i>
      </div>
      <div class="card__content">
        <h3 class="h2">Vanaf een veiling</h3>
        <p class="p">Bijv. een veiling als BVA of Troostwijk</p>
      </div>
    </div>

    <div class="error" v-if="$v.type.$error && !$v.type.required">
      Kies een type
    </div>
    <button @click="nextStep" class="btn btn__filled w-100">Volgende</button>
    <button
      @click="goToPreviousRoute"
      class="btn btn__simple btn__left btn__backbt"
    >
      <i class="fas fa-chevron-left"></i> Terug
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Type",
  computed: {
    ...mapFields([
      "type",
      "routes",
      "ophaalAdres",
      "afleverAdres",
      "toLocation",
      "fromLocation"
    ])
  },
  mounted() {
    if (this.fromLocation !== null) {
      this.ophaalAdres.plaatsnaam = this.fromLocation.address.freeformAddress;
      this.ophaalAdres.land = this.fromLocation.address.country;
    }

    if (this.toLocation !== null) {
      this.afleverAdres.plaatsnaam = this.toLocation.address.freeformAddress;
      this.afleverAdres.land = this.toLocation.address.country;
    }
  },
  methods: {
    setType(type) {
      this.type = type;
      setTimeout(() => {
        this.$root.goToNextRoute();
      }, 150);
    },
    nextStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$root.goToNextRoute();
    }
  },
  validations: {
    type: {
      required
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  height: 100px;
  display: flex;
  align-items: center;
  border: 1px solid var(--light-grey);
  border-left-width: 5px;
  margin-bottom: 10px;
  transition: border-color 300ms ease-in-out;
  cursor: pointer;

  @media only screen and (max-width: 890px) {
    height: auto;
    min-height: 100px;
    padding: 10px 10px 10px 0;
  }

  &.active {
    border-left-width: 5px;
    border-left-color: var(--orange);

    .card__icon {
      color: rgba(0, 0, 0, 0.8);
    }
  }

  &__icon {
    color: var(--grey);
    width: 35px;
    height: 35px;
    margin-left: 25px;
    margin-right: 25px;
    font-size: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    .h2 {
      margin: 0;
      line-height: 1.3;
    }

    .p {
      margin: 0px;
      line-height: 1.3;
    }
  }
}
.card.active .card__icon {
  color: var(--orange);
}
.card:hover .card__icon,
.card:hover .h2 {
  color: var(--gray);
}
.card.active {
  border-left-color: var(--orange);
}
.card:hover {
  border-left-width: 5px;
  border-left-color: #788088;
}
.btn {
  margin-top: 20px;
}
</style>
